import React from 'react';
import { aboutImage } from '../mock';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="section" style={{ background: 'var(--sm-ivory)', position: 'relative' }}>
      <div className="container-x">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: 96, alignItems: 'center' }} className="about-grid">
          <div style={{ position: 'relative' }}>
            <div style={{ aspectRatio: '3/4', overflow: 'hidden' }}>
              <img src={aboutImage} alt="Corporate operations" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ position: 'absolute', top: -24, right: -24, background: 'var(--sm-cream)', border: '1px solid var(--sm-line)', padding: '20px 24px', maxWidth: 220 }}>
              <div className="serif" style={{ fontSize: 34, color: 'var(--sm-navy)' }}>Since<br/>2003</div>
              <div style={{ fontSize: 11, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--sm-muted)', marginTop: 8 }}>Building the Platform</div>
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
              <span className="hairline" />
              <span className="overline">About the Company</span>
            </div>
            <h2 className="serif" style={{ fontSize: 'clamp(36px, 4.5vw, 60px)', lineHeight: 1.08, letterSpacing: '-0.015em', margin: 0, color: 'var(--sm-navy)' }}>
              Vision, execution, and an instinct for opportunity.
            </h2>
            <p style={{ marginTop: 28, fontSize: 16.5, lineHeight: 1.85, color: 'var(--sm-muted)', textAlign: 'justify' }}>
              ES Investments Management LLC is a New York-based company recognized for its impact in global apparel and off-price distribution. The company was built on curiosity, resourcefulness, and a deep understanding of international trade. The same principles continue to guide our approach today.
            </p>
            <p style={{ marginTop: 20, fontSize: 16.5, lineHeight: 1.85, color: 'var(--sm-muted)', textAlign: 'justify' }}>
              Two decades of sourcing across Asia and mastering apparel supply chains led us to the off-price market, where major brands meet real value through disciplined execution. Today, ES Investments Management LLC operates across distribution and real estate investment from New York City, with processing capabilities in California and Florida.
            </p>

            <div style={{ marginTop: 40 }}>
              <Link to="/about" className="link-underline" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, fontSize: 12, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--sm-navy)', fontWeight: 600, textDecoration: 'none' }}>
                Read the Full Story <ArrowRight size={16} />
              </Link>
            </div>

            <div style={{ marginTop: 56, paddingTop: 32, borderTop: '1px solid var(--sm-line)', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
              <div>
                <div className="serif" style={{ fontSize: 30, color: 'var(--sm-navy)' }}>Retail</div>
                <div style={{ fontSize: 12, letterSpacing: '0.14em', color: 'var(--sm-muted)', marginTop: 6 }}>Off-Price Distribution</div>
              </div>
              <div>
                <div className="serif" style={{ fontSize: 30, color: 'var(--sm-navy)' }}>Sourcing</div>
                <div style={{ fontSize: 12, letterSpacing: '0.14em', color: 'var(--sm-muted)', marginTop: 6 }}>Global Supply Chain</div>
              </div>
              <div>
                <div className="serif" style={{ fontSize: 30, color: 'var(--sm-navy)' }}>Investor</div>
                <div style={{ fontSize: 12, letterSpacing: '0.14em', color: 'var(--sm-muted)', marginTop: 6 }}>Real Estate Portfolio</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 56px !important; }
        }
      `}</style>
    </section>
  );
}
